import React, { useState } from "react";
import { requestPasswordReset } from "../api_controll/apiAdmin";
import { toast } from "react-toastify";
import "../styles/auth-password.css";

export default function ForgotPasswordPage() {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!username.trim()) {
      toast.error("Zadej uživatelské jméno.");
      return;
    }

    if (!email.trim()) {
      toast.error("Zadej email.");
      return;
    }

    try {
      setLoading(true);

      await requestPasswordReset({
        username: username.trim(),
        email: email.trim(),
      });

      setSent(true);
    } catch (e) {
      /**
       * Pořád držíme obecnou hlášku.
       * Nechceme prozrazovat, jestli username/email existuje.
       */
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>Obnovení hesla</h2>

        {sent ? (
          <div className="auth-card__success">
            Pokud údaje odpovídají existujícímu účtu, poslali jsme instrukce pro obnovení hesla.
          </div>
        ) : (
          <>
            <p>
              Zadej uživatelské jméno a email. Pokud údaje odpovídají účtu v systému,
              pošleme odkaz pro nastavení nového hesla.
            </p>

            <div className="auth-card__field">
              <label htmlFor="reset-username">Uživatelské jméno</label>
              <input
                id="reset-username"
                type="text"
                autoComplete="username"
                placeholder="Uživatelské jméno"
                value={username}
                disabled={loading}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>

            <div className="auth-card__field">
              <label htmlFor="reset-email">Email</label>
              <input
                id="reset-email"
                type="email"
                autoComplete="email"
                placeholder="Email"
                value={email}
                disabled={loading}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <button type="button" onClick={handleSubmit} disabled={loading}>
              {loading ? "Odesílám…" : "Odeslat odkaz"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}